/**
 * This handles the accessibility concerns of top-level links that
 * contain dropdowns, but also exist as links.
 *
 * Most solutions integrate ARIA menu roles for site navigation semantics,
 * which is not what we want. These roles are for application menus, not
 * lists of links in the case of a site navigation.
 *
 * @author Volum8
 * @link https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle
 * @link https://inclusive-components.design/menus-menu-buttons/
 * @link https://adrianroselli.com/2017/10/dont-use-aria-menu-roles-for-site-nav.html
 */

// Get all site list items that have children.
const submenuItems = document.querySelectorAll( 'li.menu-item-has-children' );

// Loop through the items.
submenuItems.forEach( submenuItem => {

	const activatingA = submenuItem.querySelector( 'a' );

	// Create the button that will act as the toggle.
	const submenuToggle = document.createElement( 'button' );

	// Create the semantic-less elements that will house accessible text.
	const submenuToggleArrow = document.createElement( 'span' );
	const submenuA11yText = document.createElement( 'span' );

	// Show the accessible text for screen readers.
	submenuA11yText.classList.add( 'clip' );
	submenuA11yText.innerText = `show submenu for ${activatingA.text}`;

	// Initiate the CSS styling hook for the submenu button.
	submenuToggle.setAttribute( 'data-expand-submenu', 'data-expand-submenu' );

	// Add the accessible text that a screen reader will announce when the element is focused.
	submenuToggle.setAttribute( 'aria-label', `show submenu for ${activatingA.text}` );

	// Add a down arrow should we ever bring these back into view.
	submenuToggle.innerHTML = '&#9660;';

	// Add the text to the button toggle.
	submenuToggle.appendChild( submenuA11yText );

	// Add the arrow to the button toggle.
	submenuToggle.appendChild( submenuToggleArrow );

	// Initialize the buttons as closed on load.
	submenuItem.setAttribute( 'data-submenu-open', false );

	// Set up the button expanded text.
	submenuToggle.setAttribute( 'aria-expanded', false );

	// Insert the toggle after the regular page link.
	activatingA.after( submenuToggle );

	// The function that shows the submenu.
	function showSubmenu( e ) {

		e.preventDefault();

		// Get the list item we're engaging with.
		const parentPage = activatingA.closest( 'li' );

		/**
		 * If it's not a mouseout event, we want to show the menu.
		 * If it is, we want to hide it.
		 */
		if ( e.type !== 'mouseout' ) {
			if ( parentPage.getAttribute( 'data-submenu-open' ) === 'true' ) {
				parentPage.setAttribute( 'data-submenu-open', false );
				parentPage.querySelector( 'a' ).setAttribute( 'aria-expanded', false );
				parentPage.querySelector( 'button' ).setAttribute( 'aria-expanded', false );
			} else {
				parentPage.setAttribute( 'data-submenu-open', true );
				parentPage.querySelector( 'a' ).setAttribute( 'aria-expanded', true );
				parentPage.querySelector( 'button' ).setAttribute( 'aria-expanded', true );
			}
		} else {
			parentPage.setAttribute( 'data-submenu-open', false );
			parentPage.querySelector( 'a' ).setAttribute( 'aria-expanded', false );
			parentPage.querySelector( 'button' ).setAttribute( 'aria-expanded', false );
		}
	}

	// Add the event listeners.
	submenuToggle.addEventListener( 'click', showSubmenu );
	submenuItem.addEventListener( 'mouseover', showSubmenu );
	submenuItem.addEventListener( 'mouseout', showSubmenu );

} );
